module.exports = __webpack_public_path__ + "static/img/cabinet12_7.6ea30d4d.gif";